import Dexie from "dexie"
import ForecastingTables from "@/repos/forecastingTables"

// Declare db instance
var db = new Dexie("HMS");

// Define Database Schema
db.version(1).stores({
    users: "++id, FullName, IsGlobalAdmin",
    userAccess: "++id, Access, PlantID"
});

db.version(2).stores({
	forecastingPlants: "PlantID",
	forecastingCropSummaries: "CropLocationID, PlantID, ProductCategoryID",
	forecastingVarietySummaries: "VarietyID",
	forecastingCropDetails: "CropLocationID",
	forecastingCropForecasts: "[CropLocationID+ForecastDate]",
	forecastingCropNotes: "[CropLocationID+OriginalDate]",
	forecastingCropPhotos: "[CropLocationID+OriginalDate]",
	forecastingUnsentCropDetails: "++id",
	forecastingUnsentCropForecasts: "++id",
	forecastingUnsentCropNotes: "++id",
	forecastingUnsentCropPhotos: "++id"
});

db.version(3).stores({
	sprayMasterData: "++id",
	spraySpraies: "[SprayID+AddDateTime]",
	sprayPlants: "PlantID",
	sprayDivisions: "DivisionID",
	sprayLocations: "LocationID",
	spraySprayConfigurations: "SprayConfigurationID",
	sprayUnAddSpraies: "++id",
	sprayUnUpdateSpraies: "++id",
	sprayUnDeleteSprayIDs: "++id"
});

db.version(4).stores({
	forecastProfiles: "BerriesForecastProfileID"
});

db.version(5).stores({
	weatherData: "PlantID"
});

db.version(6).stores({
	traps: "TrapID, PlantID, LocationID",
	trapLocations: "LocationID",
	trapInspections: "[TrapInspectionID+TrapID], TrapInspectionDetailID, TrapInspectionID, TrapID",
	trapInspectionsUnsent: "++id",

	scoutings: "ScoutingID",
	scoutingsUnsent: "++id",

	pestConfigurations: "PestConfigurationID"
});

// Clear original forecasting tables
db.version(7).stores({
    forecastingPlants: null,
    forecastingCropSummaries: null,
    forecastingVarietySummaries: null,
    forecastingCropDetails: null,
    forecastingCropForecasts: null,
    forecastingCropNotes: null,
    forecastingCropPhotos: null,
    forecastingUnsentCropDetails: null,
    forecastingUnsentCropForecasts: null,
    forecastingUnsentCropNotes: null,
    forecastingUnsentCropPhotos: null,
    forecastProfiles: null,
    weatherData: null
});

// Create new forecasting tables
db.version(8).stores({
    [ForecastingTables.Plants]: "plantId",
    [ForecastingTables.Weather]: "plantId, temperatureDate",
    [ForecastingTables.Crops]: "cropLocationId, [plantId+productCategoryId]",
    [ForecastingTables.Varieties]: "[cropLocationId+varietyId], cropLocationId, varietyId",
    [ForecastingTables.Forecasts]: "[cropLocationId+varietyId+forecastDate], cropLocationId, varietyId, forecastDate",
    [ForecastingTables.Notes]: "[cropLocationId+varietyId+raisedAt], cropLocationId, varietyId",
    [ForecastingTables.UnsentForecasts]: "[cropLocationId+varietyId+forecastDate], cropLocationId, varietyId, forecastDate",
	[ForecastingTables.NoteAlertCategories]: "berriesForecastNoteAlertCategoryId",
	[ForecastingTables.UnsyncedNotes]: "[cropLocationId+varietyId+raisedAt], cropLocationId, varietyId",
	[ForecastingTables.UnsentCropVarieties]: "[cropLocationId+varietyId], cropLocationId, varietyId",
	[ForecastingTables.FinancialYearCalendars]: "[financialYear], startDate"

});

// Create new public holidays table
db.version(9).stores({
	publicHolidays: "ID"
})

db.version(10).stores({
	[ForecastingTables.NuPointSprays]: "++id, LocationID"
})

db.version(11).stores({
	scoutingCropStages: "ScoutingCropStageID"
})

export default db